/*
 * Ryan O'Dowd
 * 2019-06-08
 * © Copyright 2019 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import {
  Image,
  TouchableOpacity,
  View,
} from 'react-native';
import React, {
  // @TODO: useEffect,
  useState,
} from 'react';
import {
  logout,
  setLightDarkMode,
} from '@utils/store/actions';
import Button from '@components/common/Button';
import DownloadLinks from '@website/components/DownloadLinks';
// @TODO: import FeedbackChat from '@containers/FeedbackChat';
import IconButton from '@components/common/IconButton';
import Menu from '@components/common/Menu';
import Text from '@components/common/Text';
import Tooltip from '@components/common/Tooltip';
import getStyles from './styles';
import globals from '@utils/globals';
import hooks from '@hooks';

const WebHeader = (props: HeaderProps) => {
  const dispatch = hooks.useTypedDispatch();
  const navigation = hooks.useNavigation();
  const styles = hooks.useStyles(getStyles);

  // @TODO: const [_feedbackChatIsOpen, setFeedbackChatIsOpen] = useState(false);
  const [_isMoreMenuOpen, setIsMoreMenuOpen] = useState(false);
  const [_isAccountMenuOpen, setIsAccountMenuOpen] = useState(false);

  const user = hooks.useTypedSelector((state) => state.userMasqueradingAs || state.oakUser);
  // @TODO: const organizationCampaigns = hooks.useTypedSelector((state) => state.organizationCampaigns);
  const myClassroom: any = hooks.useTypedSelector((state) => Object.values(state.classrooms).pop()); // @TODO: what if user has more than one classroom?
  const photoUrl = hooks.useGetPhotoUrl(user?.username, true); // @TODO: forcerefresh needs to be true on web because it doesn't have a local cache
  const isAdmin = hooks.useIsAdmin();

  /* @TODO: is this necessary? if so, i don't think this is the right component for it
  useEffect(() => {
    // we've set component state variables with data from location.state, so can delete those now
    window.history.replaceState({}, '');
  }, [location.state]);
  */

  return (
    <View style={styles.container}>
      <View style={styles.headerInner}>
        <TouchableOpacity
          style={styles.logoAndName}
          onPress={() => navigation.navigate('/')}
        >
          <Image style={styles.logo} source={globals.env === 'prod' ? require('@assets/img/logo.png') : require('@assets/img/logo_dev.png')} alt='logo' />
          {(globals.deviceType !== 'mobile' && !props.isWebApp && styles.windowWidth >= 840) && <Text style={styles.appTitle}>Wrinkly</Text>}{/* @TODO: don't hardcode 850 */}
        </TouchableOpacity>
        {props.navigationTabs &&
          <View style={[styles.navigationTabsWrapper, globals.deviceType === 'mobile' && styles.navigationTabsWrapperMobile]}>
            {props.navigationTabs}
          </View>
        }
        <View style={styles.buttons}>
          {!user
            ? (
              <Button// @TODO: might be a little bit big due to default web scale
                mode='text'
                theme={styles.colors.white}
                onPress={() => navigation.navigate(`/app?redirectUrl=${location.pathname + location.search}`)}// @TODO: shouldn't have to redirect to /app (use Navigate like in index/index.web.tsx)
              >
                Sign in
              </Button>
            ) : (
              <React.Fragment>
                <View>
                  <Menu
                    statusBarHeight={styles.safeAreaInsets.top}// @TODO: abstract menu to oak component and abstract this prop away
                    anchor={
                      <Tooltip title='Account'>
                        <IconButton
                          icon='account-circle'
                          iconColor={styles.colors.white}
                          onPress={() => setIsAccountMenuOpen(true)}
                        />
                      </Tooltip>
                    }
                    visible={_isAccountMenuOpen}
                    onDismiss={() => setIsAccountMenuOpen(false)}
                  >
                    <View
                      key='account'
                      style={styles.profileInfoWrapper}
                    >
                      <Image style={styles.userImage} source={photoUrl || require('@assets/img/avatar.png')} alt='profile' />
                      <View style={styles.userInfoWrapper}>
                        <Text style={styles.displayNameText}>{user.display_name}</Text>
                        <Text style={styles.usernameText}>{user.username}</Text>
                        <Text style={styles.emailText}><Text style={styles.italicized}>{user.auth_provider_info}</Text></Text>
                      </View>
                    </View>
                    <Menu.Item
                      title='App'
                      onPress={() => navigation.navigate('/app')}
                    />
                    {!!myClassroom &&
                      <Menu.Item
                        title='My classroom'
                        onPress={() => navigation.navigate(`/schools/${myClassroom.school.id}/classrooms/${myClassroom.id}`)}
                      />
                    }
                    {/* @TODO:
                    {!!organizationCampaigns.length &&
                      <Menu.Item
                        title='My campaigns'
                        onPress={() => navigation.navigate('/campaigns')}
                      />
                    }
                    */}
                    <Menu.Item
                      title='Sign out'
                      onPress={() => {
                        dispatch(logout());
                        setIsAccountMenuOpen(false);
                      }}
                    />
                    {isAdmin &&
                      <View>
                        <View style={styles.divider} />
                        <Text style={styles.menuSectionHeader}>Admin</Text>
                        <Menu.Item
                          style={styles.nested(1)}
                          title='Admin dashboard'
                          onPress={() => navigation.navigate('/admin')}
                        />
                        <Menu.Item
                          style={styles.nested(1)}
                          title='Oakwood classroom'
                          onPress={() => navigation.navigate('/schools/1/classrooms/1')}
                        />
                      </View>
                    }
                  </Menu>
                </View>
                {/* @TODO:
                {_feedbackChatIsOpen && <FeedbackChat onClose={() => setFeedbackChatIsOpen(false)} />}
                */}
              </React.Fragment>
            )
          }
          <Tooltip title='Help'>{/* @TODO: hide if props.isWebApp? or at least don't navigate away from /app/* prefix because that changes the rest of the header too */}
            <IconButton
              icon='help-circle'
              iconColor={styles.colors.white}
              onPress={() => navigation.navigate('/help')}
            />
          </Tooltip>
          {!props.isWebApp && // @TODO: maybe don't hide this...just show different options? would be nice to "go to website" or something
            <View>
              <Menu
                statusBarHeight={styles.safeAreaInsets.top}// @TODO: abstract menu to oak component and abstract this prop away
                anchor={
                  <Tooltip title='More options'>
                    <IconButton
                      icon='dots-vertical'
                      iconColor={styles.colors.white}
                      onPress={() => setIsMoreMenuOpen(true)}
                    />
                  </Tooltip>
                }
                visible={_isMoreMenuOpen}
                onDismiss={() => setIsMoreMenuOpen(false)}
              >
                <Menu.Item
                  style={styles.menuItem}
                  title='About'
                  leadingIcon='information'
                  onPress={() => {
                    navigation.navigate('/about');
                    setIsMoreMenuOpen(false);
                  }}
                />
                <Menu.Item
                  style={styles.menuItem}
                  title='Articles'
                  leadingIcon='storefront'
                  onPress={() => {
                    navigation.navigate('/articles');
                    setIsMoreMenuOpen(false);
                  }}
                />
                {/* @TODO:
                <Menu.Item
                  style={styles.menuItem}
                  value='Podcast'
                  leadingIcon='headphones'
                  onPress={() => {
                    window.open('https://pca.st/8fgqsyos', '_blank');
                    setIsMoreMenuOpen(false);
                  }}
                />
                */}
                <Menu.Item
                  style={styles.menuItem}
                  title='faith.tools'
                  leadingIcon='newspaper'
                  onPress={() => {
                    window.open('https://faith.tools/posts/a-peek-behind-the-curtain-wrinkly-scripture-memorization/', '_blank');
                    setIsMoreMenuOpen(false);
                  }}
                />
                {!!user &&
                  <Menu.Item
                    style={styles.menuItem}
                    title={`Switch to ${styles.isDarkMode ? 'light' : 'dark'} mode`}
                    leadingIcon={styles.isDarkMode ? 'weather-sunny' : 'moon-waning-crescent'}
                    onPress={() => {
                      const newMode = styles.isDarkMode ? 'light' : 'dark';
                      dispatch(setLightDarkMode(newMode));
                      setIsMoreMenuOpen(false);
                    }}
                  />
                }
                <View style={styles.downloadsWrapper}>
                  <DownloadLinks />
                </View>
              </Menu>
            </View>
          }
        </View>
      </View>
    </View>
  );
};

class HeaderProps {
  centerComponent?: React.ReactNode; // @TODO: not used?
  navigationTabs?: React.ReactNode;
  isWebApp?: boolean; // @TODO: currently isn't used, but it should be
};

export default WebHeader;
